import getData from 'api/getData'
import cleanSlug from 'util/cleanSlug'

const state = {
  data: {},
  currentLanguage: 'de',
  currentPage: {},
  loading: false,
  loaded: false,
  error: false,
  authenticatedPages: []
}

const actions = {
  loadData ({ commit, state }, lang) {
    lang ? commit('LANGUAGE_CHANGE', lang) : null
    commit('DATA_LOAD')
    if (!state.loaded || state.data.lang !== state.currentLanguage) {
      return getData(state.currentLanguage).then((response) => {
        commit('DATA_SAVE', response)
      })
      .catch((error) => {
        console.log(error)
        commit('DATA_CANCEL_LOAD')
        commit('DATA_ERROR', error)
        /**
         * You could also emit a global error here that then triggers the
         * <Error /> view in the <App /> component. For example if you use a store
         * to load a single post and the api returns a 404. Then it could make sense
         * to dispatch it like so:
         *
         *   // ...
         *   .catch((error) => {
         *     commit('DATA_CANCEL_LOAD')
         *     commit('DATA_ERROR', error)
         *     dispatch('error', { error })
         *   })
         *
         **/
      })
    } else {
      return true
    }
  },
  changeLanguage ({ dispatch, commit, state }, lang) {
    if (state.currentLanguage !== lang) {
      commit('LANGUAGE_CHANGE', lang)
    }
  },
  setCurrentPage ({ dispatch, commit }, page) {
    commit('SAVE_CURRENT_PAGE', page)
  },
  authenticatePage ({ dispatch, commit }) {
    commit('PAGE_AUTHENTICATE')
  }
}

const mutations = {
  DATA_LOAD (state, data) {
    state.loading = true
  },
  DATA_CANCEL_LOAD (state) {
    state.loading = false
  },
  DATA_ERROR (state, error) {
    state.error = error
    state.loading = false
  },
  DATA_SAVE (state, data) {
    state.data = data
    state.loaded = true
    state.loading = false
    state.error = false
  },
  LANGUAGE_CHANGE (state, lang) {
    state.currentLanguage = lang
  },
  SAVE_CURRENT_PAGE (state, page) {
    state.currentPage = page
    // console.log('current page', state.currentPage.polylang)
  },
  PAGE_AUTHENTICATE (state) {
    if (state.authenticatedPages.indexOf(state.currentPage.id) === -1) state.authenticatedPages.push(state.currentPage.id)
  }
}

const getters = {
  loaded: state => state.loaded,
  loading: state => state.loading,
  lang: state => state.currentLanguage,
  options: state => state.data && state.data.options ? state.data.options : false,
  pages: state => state.data && state.data.pages ? state.data.pages : false,
  protected: state => state.data && state.currentPage ? state.currentPage.content.protected : false,
  pageAuthenticated: state => state.data && state.currentPage ? (state.authenticatedPages.indexOf(state.currentPage.id) !== -1) : false,
  currentPage: state => state.data && state.currentPage ? state.currentPage : false,
  otherLangLink: (state) => {
    const otherLang = state.currentLanguage === 'de' ? 'en' : 'de'
    // const urlRegex = /^https?:\/\/(www\.)*(.*)(\.[a-z]*)/
    if (state.currentPage && state.currentPage.polylang) {
      if (state.currentPage.polylang.translations && state.currentPage.polylang.translations[otherLang]) {
        // const otherLangLink = state.currentPage.polylang.translations[otherLang].permalink.replace(urlRegex, '')
        return state.currentPage.polylang.translations[otherLang].permalink
      } else {
        return otherLang
      }
    }
  },
  /**
   * getMenu getter is a function so it must called like this this.getMenu('main')
   */
  getMenu: (state, getters) => (location) => {
    if (!state.loaded) return false
    if (!state.data.menus || !state.data.menus[location]) return false
    return state.data.menus[location].menu
  },
  getPageBySlug: (state, getters) => (slug) => {
    if (!state.loaded) return false
    if (!state.data.pages) return false
    // console.log('getPageBySlug: ' + cleanSlug(slug))
    return state.data.pages.find(p => p.uri === cleanSlug(slug))
  },
  getPageById: (state, getters) => (id) => {
    if (!state.loaded) return false
    if (!state.data.pages) return false
    return state.data.pages.find(p => p.id === id)
  },
  getParentsById: (state, getters) => (id) => {
    if (!state.loaded) return false
    if (!state.data.pages) return false

    const parentsArray = []
    let currentPage = state.data.pages.find(p => p.id === id)
    parentsArray.unshift(currentPage)

    while (currentPage.parent) {
      const parentPage = state.data.pages.find(p => p.id === currentPage.parent)
      parentsArray.unshift(parentPage)
      currentPage = parentPage
    }

    return parentsArray
  },
  getStringTranslation: (state, getters) => (title) => {
    if (!state.loaded) return false
    const translation = state.data.options.translation.find(t => t.title === title)
    return translation ? translation.text : ''
  }
}

const module = {
  state,
  actions,
  mutations,
  getters
}

export default module



// WEBPACK FOOTER //
// ./client/store/data.js